import React from 'react';
import { Link } from 'react-router-dom';

export const UnauthorizedPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl shadow-sm p-8 text-center">
        <h1 className="text-2xl font-bold text-slate-900 mb-3">Access denied</h1>
        <p className="text-slate-600 mb-6">
          Your account is authenticated, but it does not have permission to open this area.
        </p>
        <Link
          to="/dashboard"
          className="inline-flex items-center justify-center rounded-xl bg-slate-900 text-white px-4 py-2 font-medium hover:bg-slate-800"
        >
          Return to dashboard
        </Link>
      </div>
    </div>
  );
};
